import { parseEntityRef } from '@backstage/catalog-model';

export interface RepositoryNameParts {
  /** Entity ref from the System dropdown, e.g. `system:default/billing`. */
  systemName?: string;
  /** Entity ref from the Service Group dropdown. */
  serviceGroupName?: string;
  /** Free text from the Service name box. */
  serviceName?: string;
}

/** Lower case, anything that is not a letter or digit becomes a single hyphen. */
const slug = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** The bare name of an entity ref, or the input as-is if it is not a full ref. */
const refName = (ref: string): string => {
  try {
    return parseEntityRef(ref).name;
  } catch {
    return ref;
  }
};

/**
 * The standard repository name, `[system]-[service-group]-[descriptor]`, built
 * from whatever has been chosen so far. Missing parts are left out, so it fills
 * in as the user works down the form.
 */
export const composeRepositoryName = ({
  systemName,
  serviceGroupName,
  serviceName,
}: RepositoryNameParts): string =>
  [
    systemName ? refName(systemName) : '',
    serviceGroupName ? refName(serviceGroupName) : '',
    serviceName ?? '',
  ]
    .map(slug)
    .filter(Boolean)
    .join('-');
